import { Component, OnInit } from '@angular/core';
import { IFormGroup } from '@shared-libs/interfaces';
import { Action, NavigationDataKey, UserPermissions } from '@shared-libs/enums';
import { NavigationService } from '@shared-services/navigation.service';
import { formIsValid } from '@shared-libs/helpers';
import { ValidationService } from '@shared-services/validation.service';
import { IQuestionCategory } from '@internal-models/question-category.model';
import { QuestionCategoryProvider } from '@internal-providers/question-category.provider';
import { QuestionCategoryFormFactory } from '@internal-factories/forms/question-category-form.factory';

@Component({
	selector: 'question-category-component',
	templateUrl: 'question-category.component.html',
	styleUrls: ['./question-category.component.scss'],
})
export class QuestionCategoryComponent implements OnInit {
	public action: Action;
	public questionCategory: IQuestionCategory;
	public questionCategoryForm: IFormGroup<IQuestionCategory>;

	public readonly UserPermissions: typeof UserPermissions = UserPermissions;

	constructor(
		private readonly navigationService: NavigationService,
		private readonly validationService: ValidationService,
		private readonly provider: QuestionCategoryProvider
	) {}

	public ngOnInit(): void {
		this.action = this.navigationService.getNavigationData(NavigationDataKey.action);
		this.questionCategory = this.navigationService.getNavigationData(NavigationDataKey.questionCategory);
		this.initializeForm(this.questionCategory);
	}

	public initializeForm(questionCategory: IQuestionCategory): void {
		this.questionCategoryForm = QuestionCategoryFormFactory.create(questionCategory);
	}

	public async createOrUpdate(): Promise<void> {
		if (formIsValid(this.questionCategoryForm, QuestionCategoryComponent)) {
			switch (this.action) {
				case Action.CREATE:
					const questionCategory = await this.provider.create(this.questionCategoryForm.value);
					this.navigationService.navigateBack({ action: Action.CREATE, questionCategory });
					break;
				case Action.UPDATE:
					await this.provider.update(this.questionCategory.id, this.questionCategoryForm.value);
					this.navigationService.navigateBack({ action: Action.UPDATE });
					break;
			}
		}
	}

	public async delete(): Promise<void> {
		if (await this.validationService.actionIsConfirmed('QUESTION_CATEGORY')) {
			await this.provider.delete(this.questionCategory.id);
			this.navigationService.navigateBack({ action: Action.DELETE });
		}
	}
}
